import { Button } from '@/features/button';
import { IconArrowDown, IconArrowSquareLeft } from '@/features/icons';
import { Modal } from '@/features/modal';
import SafeHtml from '@/components/safe-html';
import useModal from '@/utils/use-modal';
import { useFetchIranianWomenData } from '../../_utils/use-fetch-iranian-women-data';
const HeroSectionText = () => {
  const {
    handleOpenModal,
    handleCloseModal,
    isModalOpen
  } = useModal();
  const {
    data
  } = useFetchIranianWomenData();
  const headerData = data?.header;
  const handleScrollToStories = (event: React.MouseEvent) => {
    event.preventDefault();
    const target = document.getElementById('iranian-women');
    if (!target) return;
    target.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  return <>
            <div className='flex flex-col items-center gap-3 text-text-black lg:items-start lg:gap-4'>
                <h1 className='text-title-20 font-bold lg:text-[40px] lg:leading-normal'>{headerData?.title}</h1>
                <p className='text-center text-body-14 lg:text-right lg:text-title-18'>{headerData?.description}</p>
                <div className='flex items-center gap-2.5'>
                    <Button graphicStyle='filled' size='medium' icon={{
          element: <IconArrowDown className='h-6 w-6 max-lg:animate-bounce' />,
          position: 'left'
        }} className='absolute bottom-4 right-1/2 z-10 translate-x-1/2 font-medium lg:relative lg:bottom-auto lg:right-auto lg:translate-x-0' onClick={handleScrollToStories} data-sentry-element="Button" data-sentry-source-file="hero-text.tsx">
                        کشف روایت‌ها
                    </Button>
                    <Button graphicStyle='text' size='medium' icon={{
          element: <IconArrowSquareLeft className='h-6 w-6' />,
          position: 'left'
        }} onClick={handleOpenModal} data-sentry-element="Button" data-sentry-source-file="hero-text.tsx">
                        بیشتر بخوانید
                    </Button>
                </div>
            </div>

            {headerData?.modal_content && <Modal width='w-full lg:w-[712px]' className='bottom-0 !h-fit' handleClose={handleCloseModal} isOpen={isModalOpen} title='درباره پروژه زنان پیشگام ایرانی' headClassName='[&>h3]:text-body-16 [&>h3]:font-bold' bodyClassName='mt-3'>
                    <SafeHtml content={headerData?.modal_content} className='[&>p]:!text-body-14' />
                </Modal>}
        </>;
};
export default HeroSectionText;